import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {NgClass} from '@angular/common'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'

@Component({
  selector: 'bgo-form-summary-item',
  standalone: true,
  imports: [NgClass, FaIconComponent],
  templateUrl: './form-summary-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSummaryItemComponent {
  label = input.required<string>()
  icon = input<IconDefinition>()
  border = input<boolean>(true)
  size = input<'sm' | 'default'>('default')
}
